import { render, staticRenderFns } from "./UpdateInput.vue?vue&type=template&id=55215614&scoped=true&"
import script from "./UpdateInput.vue?vue&type=script&lang=js&"
export * from "./UpdateInput.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInput.vue?vue&type=style&index=0&id=55215614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55215614",
  null
  
)

export default component.exports